//ページ内リンクのスクロール位置をヘッダーの高さ分ズラす。

function getHeaderHeight() {
    return document.querySelector('header').offsetHeight;
}

document.addEventListener('DOMContentLoaded', function () {
    var anchorLinks = document.querySelectorAll('a[href^="#"]');
    var headerHeight = getHeaderHeight();

    anchorLinks.forEach(function (anchor) {
        anchor.addEventListener('click', function (event) {
            event.preventDefault();

            var targetId = this.getAttribute('href').substring(1);
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});
